<template>
  <section>
    <div
      :style="{
        'background-image': 'url(' + require('../assets/slider/haft-poznan-slider.jpg') + ')',
      }"
      :class="
        `h-full relative bg-fixed bg-cover bg-no-repeat   px-4 sm:px-8 lg:px-16 xl:px-32 2xl:px-64 pt-48 pb-12 sm:pb-54 md:pt-54 md:pb-48 lg:pt-54 lg:pb-32 xl:pb-54 2xl:pt-54 2xl:pb-54 text-center sm:text-left`
      "
    >
      <div
        class="relative z-10 flex flex-wrap w-full p-5 bg-fixed bg-gray-700 bg-opacity-50 sm:w-2/3 lg:w-1/2 align-content-end"
        data-aos="fade-left"
        data-aos-offset="200"
        data-aos-delay="10"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
        data-aos-once="false"
      >
        <h1 class="text-3xl font-bold leading-tight text-white lg:text-4xl xl:text-5xl">
          {{ title }}
        </h1>
        <p class="w-full mt-4 text-2xl leading-snug text-white" v-html="subTitle"></p>
        <router-link
          :to="buttonLink"
          class="block w-full px-6 py-4 mt-8 text-lg text-white bg-blue-500 rounded-lg transition duration-300 ease-in-out transform sm:inline-block sm:w-auto motion-reduce:transform-none hover:-translate-y-1 hover:bg-blue-400"
          >{{ buttonText }}</router-link
        >

        <router-link
          :to="buttonLink2"
          class="block w-full px-6 py-4 mx-2 mt-8 text-lg text-white bg-blue-500 rounded-lg transition duration-300 ease-in-out transform sm:inline-block sm:w-auto motion-reduce:transform-none hover:-translate-y-1 hover:bg-blue-400"
          v-if="buttonText2 && buttonLink2"
          >{{ buttonText2 }}</router-link
        >
      </div>
    </div>
  </section>
  <!-- end hero section -->
</template>

<script>
export default {
  name: "Hero",
  props: {
    bg: {
      type: String,
      default: "bg-blue-100",
    },
    title: {
      required: true,
      type: String,
    },
    subTitle: {
      required: true,
      type: String,
    },
    buttonText: {
      required: true,
      type: String,
    },
    buttonLink: {
      required: true,
      type: String,
    },
    buttonText2: {
      required: true,
      type: String,
    },
    buttonLink2: {
      required: true,
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped></style>
